<template>
  <form @submit.prevent="submitForm">
    <div class="form-control" :class="{ invalid: !mobile.isValid }">
      <label for="mobile">Mobile</label>
      <input id="mobile" v-model.trim="mobile.val" type="text" @blur="clearValidity('mobile')">
      <p v-if="!mobile.isValid">
        Mobile number must not be empty.
      </p>
    </div>
  
    <div class="form-control" :class="{ invalid: !password.isValid }">
      <label for="password">Password</label>
      <input id="password" v-model.trim="password.val" type="password" @blur="clearValidity('password')">
      <p v-if="!password.isValid">
        Password must not be empty.
      </p>
    </div>
  
    <base-button>Login</base-button>
  </form>
  <p style="margin-top: 1rem;">
    Don't have an account?
    <router-link to="/user/registration">Register</router-link>
  </p>
</template>

  
  <script>
export default {
  emits: ['save-data'],
  data() {
    return {
      mobile: {
        val: '',
        isValid: true,
      },
      password: {
        val: '',
        isValid: true,
      },
      formIsValid: true,
    };
  },
  methods: {
    clearValidity(input) {
      this[input].isValid = true;
    },
    validateForm() {
      this.formIsValid = true;
      if (this.mobile.val === '') {
        this.mobile.isValid = false;
        this.formIsValid = false;
      }
      if (this.password.val === '') {
        this.password.isValid = false;
        this.formIsValid = false;
      }
    },
    submitForm() {
      this.validateForm();

      if (!this.formIsValid) {
        return;
      }

      const formData = {
        mobile: this.mobile.val,
        password: this.password.val,
      };

      this.$emit('save-data', formData);
    },
  },
};
  </script>
  
  <style scoped>
.form-control {
    margin: 0.5rem 0;
  }
  
  label {
    font-weight: bold;
    display: block;
    margin-bottom: 0.5rem;
  }
  
  input[type='checkbox']+label {
    font-weight: normal;
    display: inline;
    margin: 0 0 0 0.5rem;
  }
  
  input,
  textarea {
    display: block;
    width: 50%;
    border: 1px solid #ccc;
    border-radius: 8px;
    /* Rounded edges */
    padding: 0.5rem;
    /* Inner spacing */
    font: inherit;
    transition: all 0.3s ease;
    /* Smooth transitions */
    box-sizing: border-box;
    /* Keep padding inside width */
  }
  
  input:focus,
  textarea:focus {
    background-color: #f0e6fd;
    outline: none;
    border-color: #3d008d;
  }
  
  
  input[type='checkbox'] {
    display: inline;
    width: auto;
    border: none;
  }
  
  input[type='checkbox']:focus {
    outline: #3d008d solid 1px;
  }
  
  h3 {
    margin: 0.5rem 0;
    font-size: 1rem;
  }
  
  .invalid label {
    color: red;
  }
  
  .invalid input,
  .invalid textarea {
    border: 1px solid red;
  }
</style>